export default {
  common: {
    submitBtn: 'ยืนยัน',
    cancelBtn: 'ยกเลิก',
    condition: 'เงื่อนໄข',
    display: 'แสดง',
    hide: 'ซ่อน'
  },
  tip: {
    select: 'กรุณาเลือก',
    input: 'กรุณาป้อน'
  },
  check: {
    checkAll: 'เลือกทั้งหมด'
  },
  upload: {
    upload: 'คลิกเพื่ออัพโหลด',
    tip: 'ลากไฟล์มาที่นี่ หรือ'
  },
  time: {
    start: 'เริ่มต้น',
    end: 'สิ้นสุด'
  },
  date: {
    start: 'เริ่มต้น',
    end: 'สิ้นสุด',
    t: 'วันนี้',
    y: 'เมื่อวาน',
    n: '7 วันที่ຜ່าນມา',
    a: 'ทั้งหมด'
  },
  form: {
    printBtn: 'พิมพ์',
    mockBtn: 'จำลอง',
    submitBtn: 'ส่ง',
    emptyBtn: 'ลบข้อมูล'
  },
  crud: {
    excel: {
      name: 'ชื่อไฟล์',
      type: 'ข้อมูล',
      typeDic: {
        true: 'ข้อมูลปัจจุบัน (ข้อมูลทั้งหมดในหน้าปัจจุบัน)',
        false: 'ข้อมูลที่เลือก (ข้อมูลที่เลือกໃນหน้าปัจจุບັນ)'
      },
      prop: 'เขตข้อมูล',
      params: 'พารามิเตอร์',
      paramsDic: {
        header: 'หัวตาราง',
        data: 'แหล່ງข้อมูล',
        headers: 'หัวตารางที่ซับซ้อน',
        sum: 'รวมสถิติ'
      }
    },
    filter: {
      addBtn: 'เพิ่มเงື່ອນໄข',
      clearBtn: 'ลบข้อมูล',
      resetBtn: 'ลบเงື່ອນໄข',
      cancelBtn: 'ยกเลิก',
      submitBtn: 'ยืนยัน'
    },
    column: {
      name: 'ชื่อเขต',
      hide: 'ซ่อน',
      fixed: 'คงที่',
      filters: 'กรอง',
      sortable: 'สามารถเรียงลำดับได้',
      index: 'ลำดับ',
      width: 'ความกว้าง'
    },
    emptyText: 'ไม่มีข้อมูล',
    tipStartTitle: 'ตารางปัจจุບັນបានเลือก',
    tipEndTitle: 'รายการ',
    editTitle: 'แก้ไข',
    copyTitle: 'คัดลอก',
    addTitle: 'เพิ่ม',
    viewTitle: 'ดู',
    filterTitle: 'เงື່ອນໄขกรอง',
    showTitle: 'แสดง/ซ่อนเขต',
    menu: 'การประຕິบัติ',
    addBtn: 'เพิ่ม',
    show: 'แสดง',
    hide: 'ซ่อน',
    open: 'ขยาย',
    shrink: 'ยกเลิกขยาย',
    printBtn: 'พิมพ์',
    mockBtn: 'จำลอง',
    excelBtn: 'ส่งออก',
    updateBtn: 'อัพเดท',
    cancelBtn: 'ยกเลิก',
    searchBtn: 'ค้นหา',
    emptyBtn: 'ลบข้อมูล',
    menuBtn: 'ฟังก์ชัน',
    saveBtn: 'บันทึก',
    viewBtn: 'ดู',
    editBtn: 'แก้ไข',
    copyBtn: 'คัดลອກ',
    delBtn: 'ลบ'
  }
};
